import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type createAOFileDataType = {
  company_id: string;
  ao_id: string;
  name: string;
  file_data: string;
  successCallback: Function;
  errorCallback: Function;
  resultKey: string;
};

export default ({
  company_id,
  ao_id,
  name,
  file_data,
  successCallback,
  errorCallback,
  resultKey = 'addAOFileData',
}: createAOFileDataType) =>
  requestAsync({
    url: endpoints.getAddAOFileUrl(company_id, ao_id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getAddAOFileUrl(company_id, ao_id),
    body: {
      name,
      file_data,
    },
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
